import {
  CONTABLE_DASHBOARD_FETCH_REQUEST,
  CONTABLE_DASHBOARD_FETCH_SUCCESS,
  CONTABLE_DASHBOARD_FETCH_FAILURE,
  CONTABLE_DASHBOARD_FETCH_RESET,
} from "redux/types/contableTypes";

const initialState = {
  dashboard: {
    loading: false,
    data: null,
    error: null,
  },
};

const contableReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONTABLE_DASHBOARD_FETCH_REQUEST:
      return {
        ...state,
        dashboard: {
          ...state.dashboard,
          loading: true,
          error: null,
        },
      };

    case CONTABLE_DASHBOARD_FETCH_SUCCESS:
      return {
        ...state,
        dashboard: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };

    case CONTABLE_DASHBOARD_FETCH_FAILURE:
      return {
        ...state,
        dashboard: {
          ...state.dashboard,
          loading: false,
          error: action.payload,
        },
      };

    case CONTABLE_DASHBOARD_FETCH_RESET:
      return {
        ...state,
        dashboard: initialState.dashboard,
      };

    default:
      return state;
  }
};

export default contableReducer;
